<template>
    <nav aria-label="Page navigation" v-if="showPagination">
        <ul :class="['pagination',className]">
            <li v-for="(link, key) in links" :key="key" :class="['page-item', isActive(link) ? 'active' : '']">
                <inertia-link class="page-link" :href="link.url" v-if="link.url" v-html="link.label"></inertia-link>
                <a href="#" class="page-link" v-else @click.prevent="handleNoLink" v-html="link.label"></a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name:'InertiaPagination',
    props: {
        links: Array,
        className: {default: 'justify-content-center'}
    },
    computed: {
        showPagination() {
            return this.links.length > 3
        }
    },
    methods: {
        isPrevious(link) {
            try
            {
                return link.label.includes('Previous');
            }
            catch (ex)
            {
                return false;
            }
        },
        isNext(link) {
            try
            {
                return link.label.includes('Next');
            }
            catch (ex)
            {
                return false;
            }
        },
        isActive(link) {
            return (link.active === true);
        },
        handleNoLink() {
            return false
        }
    }
}
</script>
